
// src/web/components/search-timeline-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/search-timeline-page'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import Diary from './diary.jsx'
import { InfiniteScroll, InviewSensor } from './infinite-scroller';
import SearchConditions from './search-timeline-page-conditions.jsx'
import { IconButton } from 'react-toolbox/lib/button'

class SearchTimelinePage extends React.Component {

  // Add two new state variables: activeHighlightIndex and totalHighlights
  state = {
    activeHighlightIndex: 0,
    totalHighlights: 0,
    initialScroll: true
  }

  componentDidUpdate(prevProps, prevState) {
    // Initialize the states when the search text is changed
    if (prevProps.params.query != this.props.params.query) {
      this.setState({
        activeHighlightIndex: 0,
        totalHighlights: 0,
        initialScroll: true
      });
    }
    const containerElement = ReactDOM.findDOMNode(this.containerRef);
    let highlightedElements = containerElement.querySelectorAll('em');

    // Update totalHighlights
    if (highlightedElements.length > prevState.totalHighlights) {
      this.setState({ totalHighlights: highlightedElements.length });
    }
   
    if (this.state.initialScroll && this.props.diaries && !this.props.isFetching && containerElement) {
      setTimeout(()=> {
        const highlightedElements = containerElement.querySelectorAll('em');
        this.setState({
          totalHighlights: highlightedElements.length,
          initialScroll: false
         });
        this.scrollToHighlightedText(0);
      }, 0);
    }
  }

  scrollToHighlightedText = (activeIndex) => {
    const containerElement = ReactDOM.findDOMNode(this.containerRef);
    if (containerElement) {
      const highlightedElements = containerElement.querySelectorAll('em');
      if (highlightedElements && highlightedElements.length > 0 && highlightedElements[activeIndex]) {
        highlightedElements[activeIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  // Handle clicking the "Next" button
  handleNextHighlight = () => {
    if (!this.props.isFetching) {
      let totalCount = this.state.totalHighlights;
      let activeIndex = this.state.activeHighlightIndex + 1;
      if (activeIndex >= totalCount) activeIndex = totalCount - 1;
  
      this.setState({ activeHighlightIndex: activeIndex });
      this.scrollToHighlightedText(activeIndex);
    }
  };

  // Handle clicking the "Prev" button
  handlePrevHighlight = () => {
    let totalCount = this.state.totalHighlights;
    let activeIndex = this.state.activeHighlightIndex - 1;
    if (activeIndex < 0) activeIndex = 0;

    this.setState({ activeHighlightIndex: activeIndex });
    this.scrollToHighlightedText(activeIndex);
  };

  onReplyScrollFrom = (offset)=> {
    //COMMENT_FORM_HEIGHTはコメントフォームの高さ
    const COMMENT_FORM_HEIGHT = 222
    //返信コメントへの返信の場合、コメントフォームまでスクロールする
    this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT)
  }

  editSearchDrawer = () => {
    this.props.editSearchDrawer()
  }
  render() {
    const {
      t,
      isFetching,
      isFetchFailed,
      hasMore,
      diaries,
      user,
      group,
      fetchDiaries,
      likeConfig,
      rightSidePage,
      editSearchDrawer,
      params,
    } = this.props

    return (
      <RightSidePage
        title={t('label:検索結果')}
        icon="search"
        innerRef={(c)=> this.rightSidePage = c}
        rightAction={[
          <IconButton icon='arrow_upward' onClick={this.handlePrevHighlight} />,
          <IconButton icon='arrow_downward' onClick={this.handleNextHighlight } />
        ]} >

        {!diaries && isFetching &&
          <Loading />
        }
        {!isFetching && <SearchConditions {...this.props} />}

        <InfiniteScroll
            ref={(content)=> this.containerRef = content}
            pageStart={0}
            hasMore={hasMore && !isFetchFailed}
            loadMore={()=> !isFetching && fetchDiaries(this.props)}
            loader={
              diaries && <Loading />
            }
            useWindow={false} >
          {diaries && diaries.map((diary)=> 
            <Diary key={diary.diary_id} diary={diary} group={group} user={user} onReplyScrollFrom={this.onReplyScrollFrom} likeConfig={likeConfig} openSidePage={rightSidePage} isBlockDisable={true} isReviewButtonDisplay={false} query={params}/>
          )}
        </InfiniteScroll>

        {diaries && diaries.length == 0 && !hasMore && !isFetching &&
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '20px' }}>
            {t('label:投稿がありません')}
          </div>
        }
        {diaries && diaries.length > 0 && !hasMore &&
          <div style={{ fontSize: '80%', padding: '0 20px', color: '#999' }}>{t('label:一番最後の投稿です')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawSearchTimelinePage = SearchTimelinePage
export default connect(SearchTimelinePage)



// WEBPACK FOOTER //
// ./src/web/components/search-timeline-page.jsx